// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__gJGPm","sendOtp":"AuthorizeToLogin_sendOtp__2Hnrx"};